import React from "react";
import OcancerzStarszPostItems from "./OcancerzStarszPostItems";

const OcancerzStarzPostFun = (props) => {
  return (
    <div
      className="posts-grid"
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "15px",
        width: "100%",
        maxWidth: "100%",
        minWidth: 0, // CRITICAL: Stops flex children from pushing bounds out
        boxSizing: "border-box",
      }}
    >
      {props.postFunction
        .map((post) => (
          <OcancerzStarszPostItems
            key={post.uid || post._id}
            onEditPost={props.onEditPost}
            postFunction={post}
            onMergeClick={props.onMergeClick}
            refreshFeedBubbles={props.refreshFeed}
          />
        ))
        .reverse()}
    </div>
  );
};

export default OcancerzStarzPostFun;
